<template>
  <div :class="themeClass" class="p-4 lg:p-8 rounded-md border border-0.5">
    <div class="flex items-start">
      <div>
        <h2 v-if="title" class="inline-flex text-md font-semibold mb-2">
          <span v-if="icon" class="mr-2"
            ><mdicon :aria-label="icon" :name="icon"
          /></span>

          {{ title }}
        </h2>
        <p class="text-base">{{ message }}</p>

        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  theme: {
    type: String,
    required: true,
    validator: (value) => ['warning', 'error', 'confirmation'].includes(value),
  },
  message: {
    type: String,
    default: '',
  },
  icon: {
    type: String,
    default: 'alert-circle',
  },
  title: {
    type: String,
    default: '',
  },
})

const themeClass = computed(() => {
  switch (props.theme) {
    case 'warning':
      return 'bg-amber-1 text-amber-2 border-amber-2 dark:bg-dark-amber-soft dark:text-amber-1 dark:border-amber-2'
    case 'error':
      return 'bg-red-4 text-red-2 border-red-3 dark:bg-dark-red-soft dark:text-dark-red dark:border-red-2'
    case 'confirmation':
      return 'bg-green-2 text-green-3 border-green-1 dark:bg-dark-green-soft dark:text-green-1 dark:border-green-1'
    default:
      return ''
  }
})
</script>
